import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FiLogOut } from 'react-icons/fi';

import { useAuth } from '../auth/AuthContext';
import './ArtistNavbar.css';
import { useAeonasUnread, ChatBadge } from './AeonasUnread';

function ArtistNavbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const chatUnread = useAeonasUnread();

  const handleLogout = async () => {
    try {
      await logout();
    } catch (err) {
      console.error('Logout fehlgeschlagen:', err);
    } finally {
      navigate('/login', { replace: true });
    }
  };

  return (
    <nav className="artist-navbar">
      <div className="artist-navbar-brand">
        <span className="artist-navbar-title">
          Aeonas
        </span>

        {user?.name && (
          <span className="artist-navbar-user">
            {user.name}
          </span>
        )}
      </div>

      <Link to="/chat" style={{marginLeft:"auto",marginRight:12,color:"inherit",fontWeight:700,textDecoration:"none"}}>✦ Chat <ChatBadge count={chatUnread.total}/></Link>
      <button
        type="button"
        className="artist-navbar-logout"
        onClick={handleLogout}
        title="Abmelden"
      >
        <FiLogOut />
        <span>Logout</span>
      </button>
    </nav>
  );
}

export default ArtistNavbar;
